// Paleta semántica del dashboard: cada categoría de dato usa siempre el mismo color
// en todos los gráficos, para que se puedan reconocer de un vistazo entre widgets.
export const DASHBOARD_COLORS = {
  base: "#003049",
  varios: "#F77F00",
  instituciones: "#588157",
  postulantes: "#4A3B6B",
  general: "#4A3B6B",
  otros: "#168AAD",
  alerta: "#4A3B6B", // reutiliza el color de postulantes como acento de alerta/oportunidad
  gold: "#FFD625", // color de marca, se mantiene por ser el nombre del plan "Gold"
};
